const _ = "__MANTINE_FORM_INDEX__";
export {
  _ as FORM_INDEX
};
